<ng-rate-list
  *ngIf="(store$ | async) as store"
  (search)="search($event)"
  (editItem)="edit($event)"
  (clearItem)="clearItem()"
  (setInquiryList)="setInquiryList($event)"
  (updateLayout)="layoutDispatcher($event)"
  (addRateSearchItem)="addRateSearchItem($event)"
  (setRateSearchList)="setRateSearchList($event)"
  (clearRateSearchList)="clearRateSearchList()"
  (setCarTypes)="setCarTypes($event)"
  [loading]="store.core.loading"
  [rateInquiryItem]="store.core.rateInquiryItem"
  [searchList]="store.core.searchList"
  [displayList]="store.core.displayList"
>
</ng-rate-list>
